import { Page as _Page } from "$components/page";
import { styled } from "@material-ui/core";

const Page = styled(_Page)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

export default Page;
